import { z } from "zod";

export const AGENT_LAUNCH_CREATE_FLOW_DISMISSAL_STORAGE_KEY =
  "replo.agentLaunch.dismissal.create-flow";

const AGENT_LAUNCH_CAMPAIGN = "2026-09";

const launchDismissalSchema = z.object({
  dismissedAt: z.string(),
  campaign: z.string(),
});

export function isAgentLaunchCreateFlowDismissed(): boolean {
  try {
    const raw = localStorage.getItem(
      AGENT_LAUNCH_CREATE_FLOW_DISMISSAL_STORAGE_KEY,
    );
    if (!raw) {
      return false;
    }
    const parsed = launchDismissalSchema.safeParse(JSON.parse(raw));
    return parsed.success && parsed.data.campaign === AGENT_LAUNCH_CAMPAIGN;
  } catch {
    return false;
  }
}

export function recordAgentLaunchCreateFlowDismissal() {
  try {
    localStorage.setItem(
      AGENT_LAUNCH_CREATE_FLOW_DISMISSAL_STORAGE_KEY,
      JSON.stringify({
        dismissedAt: new Date().toISOString(),
        campaign: AGENT_LAUNCH_CAMPAIGN,
      }),
    );
  } catch {
    // Storage can throw in private mode or at quota; showing the introduction again is safe.
  }
}
